import React from "react";
import { ArrowDownRight, Sparkles } from "lucide-react";
import { profile, clientLogos } from "../mock/mock";
import { Button } from "./ui/button";

const Hero = () => {
  const handleNav = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" aria-label="Hero" className="relative pt-32 md:pt-40 pb-16 md:pb-24 grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Top meta line */}
        <div className="flex items-center justify-between mb-12 md:mb-16 fade-up">
          <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#3d3d3a]">
            <Sparkles className="h-3.5 w-3.5" />
            Independent practice · Est. 2013
          </div>
          <div className="hidden md:block font-mono text-[11px] uppercase tracking-[0.2em] text-[#3d3d3a]">
            {profile.location}
          </div>
        </div>

        {/* Big display headline */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-end">
          <div className="lg:col-span-8 fade-up">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#6b6b66] mb-6">
              — Predrag Petrović / AI Search Strategist
            </p>
            <h1 className="font-display text-[44px] sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.98] font-medium">
              Visibility for the
              <br />
              <span className="italic font-light text-[#1a1a1a]">
                age of AI search.
              </span>
            </h1>
            <p className="mt-8 max-w-xl text-[17px] md:text-lg text-[#2a2a2a] leading-relaxed">
              I help ambitious brands get found, cited and trusted by{" "}
              <span className="underline decoration-[#C8FF3D] decoration-[6px] underline-offset-[2px]">
                ChatGPT, Perplexity, Gemini
              </span>{" "}
              and Google AI Overviews — with strategy that fuses classical SEO,
              GEO and AEO.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Button
                onClick={() => handleNav("#contact")}
                className="btn-press rounded-full bg-[#0A0A0A] hover:bg-[#1f1f1f] text-[#FAFAF7] h-12 px-7 text-sm font-medium gap-2"
              >
                Book a strategy call
                <ArrowDownRight className="h-4 w-4" />
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleNav("#work")}
                className="btn-press rounded-full h-12 px-6 text-sm font-medium text-[#0A0A0A] hover:bg-[#0A0A0A]/5"
              >
                See selected work
              </Button>
            </div>
          </div>

          {/* Right column: portrait + meta card */}
          <div className="lg:col-span-4 fade-up" style={{ animationDelay: "120ms" }}>
            <div className="relative">
              <div className="relative overflow-hidden rounded-sm bg-[#EFEFEA] aspect-[4/5]">
                <img
                  src={profile.headshot}
                  alt={profile.name}
                  className="absolute inset-0 w-full h-full object-cover object-top hover:scale-[1.02] transition-all duration-700"
                />
                <div className="absolute top-3 left-3 right-3 flex items-start justify-between">
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] bg-[#0A0A0A] text-[#FAFAF7] px-2 py-1">
                    {profile.name}
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] bg-[#FAFAF7] text-[#0A0A0A] px-2 py-1">
                    ’26 · Belgrade
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -left-4 hidden md:flex flex-col gap-1 bg-[#C8FF3D] px-3 py-2">
                <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#0A0A0A]">
                  Currently
                </span>
                <span className="text-[13px] font-medium text-[#0A0A0A] leading-tight">
                  {profile.availability}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Marquee logos */}
        <div className="mt-20 md:mt-28 border-y border-[#E5E5E0] py-6 overflow-hidden">
          <div className="flex items-center gap-16 whitespace-nowrap animate-marquee">
            {[...clientLogos, ...clientLogos, ...clientLogos].map((logo, i) => (
              <span
                key={i}
                className="font-mono text-xs md:text-sm uppercase tracking-[0.25em] text-[#6b6b66] hover:text-[#0A0A0A] transition-colors"
              >
                {logo}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
